import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

import { ParkingService } from '../lib/parking.service'
import { Auto } from '../lib/parking.types'

export const GET_AUTOS = 'get-autos'

type Props = {
  enabled?: boolean
}

export const useAutos = ({ enabled = true }: Props = {}) => {
  const { data, isLoading, isFetching, error, refetch } = useQuery<
    { data: Auto[] },
    AxiosError<ServerValidationError>,
    Auto[]
  >({
    queryKey: [GET_AUTOS],
    queryFn: () => ParkingService.getAutos(),
    select: response => response.data,
    enabled
  })

  return {
    data: data ?? [],
    isLoading,
    isFetching,
    error,
    refetch
  }
}
